import styled from 'styled-components';

export default styled.p<{ color?: string; fontSize?: string }>`
  font-family: Gotham Pro Bold;
  font-size: ${(props) => props.fontSize || '18px'};
  line-height: 24px;
  letter-spacing: -0.02em;
  color: ${(props) => props.color || props.theme.colors.dark};
`;
